import React from 'react';
import styles from './FmeaStepHeader.module.css';

interface FmeaStepHeaderProps {
  title: string;
  description?: string;
  className?: string;
}

const FmeaStepHeader: React.FC<FmeaStepHeaderProps> = ({
  title,
  description,
  className,
}) => (
  <div className={`${styles.header}${className ? ` ${className}` : ''}`}>
    <div className={styles.titleRow}>
      <h2 className={styles.title}>{title}</h2>
    </div>
    {description && <p className={styles.description}>{description}</p>}
  </div>
);

export default FmeaStepHeader;
